import faq from "../../config/faq.json";
import "./faq.css";
import { Helmet } from "react-helmet";
import Accordion from "react-bootstrap/Accordion";

export const Faq = () => {
    return (
        <>
            <title>
                <Helmet> Faq </Helmet>
            </title>
            <section id="faq" className="textBlue bgCream">
                <h1 className="text py-4 text-center">Domande Frequenti</h1>
                <div className="container py-4">
                    {faq.map((el, index) => {
                        return (
                            <div className="row">
                                <div className="col-12 my-1">
                                    <Accordion defaultActiveKey="0" flush>
                                        <Accordion.Item eventKey={index}>
                                            <Accordion.Header>{el.question}</Accordion.Header>
                                            <Accordion.Body>{el.answer}</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
        </>
    );
};
